'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _index = require('../../utils/index.js');

var _index2 = _interopRequireDefault(_index);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ItemHover = function (_React$Component) {
  (0, _inherits3.default)(ItemHover, _React$Component);

  function ItemHover() {
    (0, _classCallCheck3.default)(this, ItemHover);
    return (0, _possibleConstructorReturn3.default)(this, (ItemHover.__proto__ || (0, _getPrototypeOf2.default)(ItemHover)).apply(this, arguments));
  }

  (0, _createClass3.default)(ItemHover, [{
    key: 'getHoverClass',
    value: function getHoverClass() {
      var _props = this.props,
          styleParams = _props.styleParams,
          forceShowHover = _props.forceShowHover,
          itemType = _props.itemType;

      var hoverClass = itemType === 'video' ? ['gallery-item-hover-video'] : ['gallery-item-hover'];

      if (styleParams.isSlider || styleParams.isSlideshow || styleParams.hasThumbnails) {
        hoverClass.push(styleParams.galleryVerticalAlign);
      }

      hoverClass.push('fullscreen-' + (styleParams.fullscreen ? 'enabled' : 'disabled'));

      if (_lodash2.default.isUndefined(styleParams.itemOpacity)) {
        hoverClass.push('default');
      }

      if (forceShowHover) {
        //in mobile, when item is hovered (tapped, with all the right configurations), forceShowHover is true
        hoverClass.push('hovered');
      } else if (_index2.default.isMobile()) {
        hoverClass.push('hide-hover');
      }

      return hoverClass.join(' ');
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          shouldHover = _props2.shouldHover,
          imageDimensions = _props2.imageDimensions,
          actions = _props2.actions,
          idx = _props2.idx;

      if (!shouldHover) {
        return null;
      }
      var hoverClass = this.getHoverClass();

      var _ref = imageDimensions || {},
          marginLeft = _ref.marginLeft,
          marginTop = _ref.marginTop,
          restOfDimensions = (0, _objectWithoutProperties3.default)(_ref, ['marginLeft', 'marginTop']);

      return _react2.default.createElement(
        'div',
        {
          className: hoverClass,
          key: 'item-hover-' + idx,
          'data-hook': 'item-hover-' + idx,
          style: restOfDimensions,
          onTouchStart: actions.handleItemMouseDown,
          onTouchEnd: actions.handleItemMouseUp
        },
        this.props.children
      );
    }
  }]);
  return ItemHover;
}(_react2.default.Component);

exports.default = ItemHover;